/**
 * @file INCSUBStatusButton.js
 * @description A status display button used to visually represent status with dynamic colors and styles.
 * 
 * Props:
 * - background: CSS background color for the button (e.g., '#f0f0f0', 'rgba(0, 255, 0, 0.2)')
 * - color: Text color for the status label
 * - status: Status text to display and used for dynamic class assignment (e.g., 'active', 'inactive', etc.)
 */

import React from 'react';
import './statusButton.css';

function INCSUBStatusButton({ background, color, status }) {
    return (
        // Wrapper div with dynamic background and status-based class
        <div
            className={`INCSUBPoolInfo_active_status ${status}`}
            style={{ background: `${background}` }}
        >
            {/* Text with status and dynamic color */}
            <div
                className={`INCSUBPoolInfo_active_status_text ${status}`}
                style={{ color: `${color}` }}
            >
                {status}
            </div>
        </div>
    );
}

export default INCSUBStatusButton;
